import {createApp} from 'vue'
import ThemeCard from './ThemeCard'

const el = '.kb-component--theme-card'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ThemeCardDOM)=>{
            const props = {
                content: ThemeCardDOM.dataset.content ? JSON.parse(ThemeCardDOM.dataset.content) : {}
            }
            const component = createApp(ThemeCard, props).use(Store)
            component.mount(ThemeCardDOM)
        })
    }
}